import { create } from 'zustand';
import { waitForPermissionAndRun } from '@utils/useWaitForPermissions';

export const useProductCreateStore = create((set) => ({
  isOpen: false,
  payload: {},
  callback: null,

  openProductCreate: (payload, callback = null) => {
    // Async safety wrapper
    waitForPermissionAndRun(() => {
      set({ isOpen: true, payload, callback });
    });
  },

  close: (result) =>
    set((state) => {
      if (state.callback) state.callback(result);
      return { isOpen: false, payload: {}, callback: null };
    }),
}));

export const openProductCreate = (payload, callback = null) => {
  const store = useProductCreateStore.getState();
  store.openProductCreate(payload, callback);
};

export const closeProductCreate = () => {
  const store = useProductCreateStore.getState();
  store.close();
};
